import type { AllowedComponentName } from '~/renderer';
import { CalendarOptions } from '~/validation/options/calendar';
import { BookingFlowOptions } from '~/validation/options/bookingFlow';
import { InferredOptions } from '~/types/options';
import { MyEnvironmentOptions } from '~/validation/options/myEnvironment';

const DATASET_PREFIX = 'sCape';

/**
 * Convert the dataset on a HTML element to an object.
 * For example, data-s-cape-package-id="test123" will be converted to { packageId: 'test123' }.
 */
function dataSetToObject(dataset: DOMStringMap) {
  const obj: Record<string, string | number> = {};

  Object.keys(dataset).forEach((key) => {
    let keyWithoutPrefix = key.replace(DATASET_PREFIX, '');
    keyWithoutPrefix = keyWithoutPrefix.charAt(0).toLowerCase() + keyWithoutPrefix.slice(1);

    let value: string | number = dataset[key] || '';

    if (!Number.isNaN(Number(value))) {
      value = Number(value);
    }

    obj[keyWithoutPrefix] = value;
  });

  return obj;
}

export type Options = InferredOptions;

/**
 * Transform the dataset on a HTML element to an object and validate it.
 */
function parseOptions(componentName: AllowedComponentName, node: HTMLElement): Options {
  if (componentName === 'calendar') {
    return CalendarOptions.parse(dataSetToObject(node.dataset));
  }

  if (componentName === 'booking-flow') {
    return BookingFlowOptions.parse(dataSetToObject(node.dataset));
  }

  if (componentName === 'my-environment') {
    return MyEnvironmentOptions.parse(dataSetToObject(node.dataset));
  }

  throw new Error('Component not handled in validation');
}

export default parseOptions;
